export const toVatLabelTransformer = ({ percentage, code, description }) => {
  const formattedPercentage = percentage !== null ? `${percentage}%` : "";

  const separator1 =
    percentage !== null && (code !== null || description !== null) ? " - " : "";

  const formattedCode = code !== null ? code : "";

  const separator2 = code !== null && description !== null ? " - " : "";

  const formattedDescription = description !== null ? description : "";

  return `${formattedPercentage}${separator1}${formattedCode}${separator2}${formattedDescription}`;
};
